import gql from 'graphql-tag'

export default gql`
    mutation SaveVZF($vzfID: String!, $input: VZFDataInput!, $pdfData: VZFPDFData!, $b2b: Boolean!, $clientID: Int) {
        saveVZF(vzfID: $vzfID, input: $input, pdfData: $pdfData, b2b: $b2b, clientID: $clientID) {
            status
        }
    }
`
